import { find, findIndex } from "lodash";

export const calculateBusPosition = (
  assignment: any,
  busPosition: any,
  nextStop: any,
) => {
  if (!assignment || !nextStop || !busPosition) {
    return {
      progress: 0,
      etaInMinutes: 0,
      isHidden: true,
    };
  }

  let populateLocations: any;

  if (
    assignment.routeType === "from_school" ||
    assignment.routeType === "cca"
  ) {
    const firstLocation = { ...assignment.school, order: 1 };

    populateLocations = [firstLocation, ...assignment.locations];
  } else {
    const lastLocation = {
      ...assignment.school,
      order: assignment.locations.length + 1,
    };

    populateLocations = [...assignment.locations, lastLocation];
  }

  if (nextStop.order === 1) {
    return {
      progress: 0,
      etaInMinutes: Number(nextStop.eta),
    };
  }

  const previousLocation = find(populateLocations, {
    order: nextStop.order - 1,
  });

  const lastStopLocationIndex = findIndex(populateLocations, {
    lat: previousLocation.lat,
    lng: previousLocation.lng,
  });

  const maxProgress = 92; // set to 92 instead of 100 for better UI
  const sections = 5;
  const dropPerSection = maxProgress / sections;

  const segmentProgressByEta = [
    { max: 1, progress: maxProgress }, // section 1
    { max: 5, progress: maxProgress - dropPerSection }, // section 2
    { max: 8, progress: maxProgress - dropPerSection * 2 }, // section 3
    { max: 12, progress: maxProgress - dropPerSection * 3 }, // section 4
    { max: 20, progress: 0 }, // section 5 (fades out)
  ];

  let progress = 0;
  const segment = segmentProgressByEta.find((s) => nextStop.eta <= s.max);

  if (segment) {
    progress = segment.progress;
  }

  const onGoingProgress = Math.max(10, Math.min(100, progress));
  const lastBusProgress = lastStopLocationIndex * 100;

  return {
    progress: Number((onGoingProgress + lastBusProgress).toFixed(2)),
    etaInMinutes: Number(nextStop.eta),
    isHidden: false,
  };
};
